"use client";
import Image from "next/image";

import { AnimationListItem, ListItemAnimation } from "./animation-list-item";

import "./animation-list.scss";

type AnimationListProps = {
  animations: ListItemAnimation[];
  showPublic?: boolean;
  onAnimationSelected?: () => void;
  selectedItems?: number[];
};

const AnimationList = ({
  animations,
  showPublic = false,
  onAnimationSelected,
}: AnimationListProps) => {
  const renderList = () => {
    return animations.map((animation, index) => (
      <AnimationListItem
        animation={animation}
        showPublic={showPublic}
        key={`${index}-${animation.id}`}
        onAnimationSelected={onAnimationSelected}
      />
    ));
  };

  if (animations.length === 0) {
    return (
      <div className="w-full text-center h-100 flex flex-col items-center justify-center bg-white bg-opacity-50 rounded border border-gray-300 border-dashed">
        <p className="w-full">Sorry, nothing to see here yet!</p>
        <Image src="/images/villain.png" alt="Evil villain" width={200} height={200} />
      </div>
    );
  }

  return (
    <div className="animation-list__container">
      <ol className="animation-list">{renderList()}</ol>
    </div>
  );
};

export default AnimationList;
